<div class="container-fluid" *ngIf="contentVisble" style="padding: 0">
  <div class="row">
    <div class="col-md-12 text-right"></div>
  </div>

  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Search
  </div>
  <form
    nz-form
    [formGroup]="searchingForm"
    class="ant-advanced-search-form"
    style="
      padding: 24px;
      background: #fbfbfb;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
    "
    (ngSubmit)="onSearch()"
  >
    <div nz-row [nzGutter]="16">
      <!-- STP Name -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>STP Name</nz-form-label>
          <nz-form-control>
            <input
              nz-input
              placeholder="Enter STP Name"
              formControlName="stpName"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Application ID -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Application ID</nz-form-label>
          <nz-form-control>
            <input
              nz-input
              placeholder="Enter Application ID"
              formControlName="stpApplicationId"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Ownership -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Ownership</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Ownership Type"
              formControlName="stpOwnerShipStatusId"
            >
              <nz-option
                *ngFor="let data of stpOwnershipTypeList"
                [nzValue]="data.id"
                [nzLabel]="data.typeName"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- District -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>District</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select District"
              formControlName="sysDistrictId"
            >
              <nz-option
                *ngFor="let data of districtList"
                [nzValue]="data.id"
                [nzLabel]="data.districtName"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Occupation -->
      <!-- <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Occupation</nz-form-label>
          <nz-form-control>
            <input
              nz-input
              placeholder="Enter Occupation Name"
              formControlName="occupationName"
            />
          </nz-form-control>
        </nz-form-item>
      </div> -->
    </div>

    <!-- Buttons -->
    <div nz-row nzJustify="end" style="margin-top: 24px">
      <button nz-button nzType="primary" htmlType="submit">Search</button>

      <button
        nz-button
        nzType="default"
        style="margin: 0 12px"
        (click)="onRefresh()"
      >
        Refresh
      </button>
    </div>
  </form>

  <div class="ng-Header col-xs-12 mt-4">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> List of Archive
    STP Applications
  </div>
  <div nz-col [nzSpan]="24">
    <nz-table
      #basicTable
      [nzData]="stpApplicationDto"
      nzTableLayout="fixed"
      nzShowSizeChanger
      nzBordered
      nzSize="middle"
      nzAlign="middle"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [(nzPageSize)]="size"
      [nzShowTotal]="totalRowRangeTemplate"
      [(nzPageIndex)]="page"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzPaginationPosition]="'both'"
      [nzScroll]="{ x: '1300px' }"
    >
      <ng-template
        #totalRowRangeTemplate
        let-range="range"
        let-total
        style="text-align: left"
      >
        <div style="text-align: left">
          Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
        </div>
      </ng-template>
      <thead>
        <tr>
          <th style="text-align: center; width: 60px" rowspan="1">Sl.</th>
          <th rowspan="2" nzColumnKey="stp_name" [nzSortFn]="true">
            Name of STP
          </th>
          <th
            
            rowspan="2"
            nzColumnKey="application_id"
            [nzSortFn]="true"
          >
            Application ID
          </th>
          <th
            
            rowspan="2"
            nzColumnKey="created_at"
            [nzSortFn]="true"
          >
            Date of Application
          </th>
          <th
            
            rowspan="2"
            nzColumnKey="registration_no"
            [nzSortFn]="true"
          >
            Registration Number
          </th>
          <th
            
            rowspan="2"
            nzColumnKey="approval_date"
            [nzSortFn]="true"
          >
            Date of Approval
          </th>
          <th rowspan="2">Type of Ownership</th>
          <th rowspan="2">Ministry</th>
          <th rowspan="2">Agency</th>
          <th rowspan="2">District</th>
          <th  rowspan="2">Renew/Reapply?</th>
          <th
            
            rowspan="2"
            nzRight
            style="width: 155px"
          >
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index">
          <td style="text-align: center">{{ (page - 1) * size + 1 + i }}</td>
          <td>
              <a
                [routerLink]="['/home/stp-registration/stp-archive-application-view-renew-reapply']"
                [queryParams]="{stpMainId: data.stpMainId,stpMainDumpId: data.stpMainDumpId}"
                target="_blank"
                routerLinkActive="router-link-active"
                >{{ data.stpName }}</a
              >
          </td>
          <td >
            <a
              [routerLink]="['/home/stp-registration/stp-archive-application-view-renew-reapply']"
              [queryParams]="{stpMainId: data.stpMainId,stpMainDumpId: data.stpMainDumpId}"
              target="_blank"
              routerLinkActive="router-link-active"
              >{{ data.applicationId }}</a
            >
          </td>
          <td >
            {{ data.applicationDate | date: "dd-MM-yyyy" }}
          </td>

          <td >{{ data.registrationId }}</td>
          <td >
            {{ data.approvalDate | date: "dd-MM-yyyy" }}
          </td>
          <td>{{ data.ownerType }}</td>
          <td>{{ data.ministryName }}</td>
          <td>{{ data.agencyName }}</td>
          <td>{{ data.districtName }}</td>
          <td >
            <span
              *ngIf="data.isRenewed == true"
              class="badge badge-success"
              style="font-size: 10px"
            >
              Renew
            </span>
            <span
              *ngIf="data.isReapplied == true"
              class="badge badge-warning"
              style="font-size: 10px"
            >
              Reapply
            </span>
          </td>
          <td nzRight>
            <a
              style="margin: 2px"
              nz-button
              nzType="primary"
              title="View Application"
              [routerLink]="[
                '/home/stp-registration/stp-archive-application-view-renew-reapply',
              ]"
              [queryParams]="{ stpMainId: data.stpMainId, stpMainDumpId: data.stpMainDumpId }"
              target="_blank"
              routerLinkActive="router-link-active"
              ><i
                nz-icon
                nzType="eye"
                style="color: white"
                nzTheme="outline"
              ></i>
            </a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
